import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetailsTitle: {
        id: 'tfpa.gateway.contacts.policyroles.Name',
        defaultMessage: 'Name',
    },
    policyDetailsTitle: {
        id: 'tfpa.gateway.contacts.policyroles.FirstName',
        defaultMessage: 'First Name',
    },
    policyDetailsTitle: {
        id: 'tfpa.gateway.contacts.policyroles.LastName',
        defaultMessage: 'Last Name',
    },
    changeButton: {
        id: 'tfpa.gateway.contacts.Change',
        defaultMessage: 'Change',
    },
    cancelButton: {
        id: 'tfpa.gateway.contacts.Cancel',
        defaultMessage: 'Cancel',
    },
    required: {
        id: 'tfpa.gateway.contacts.This is a required field.',
        defaultMessage: 'This is a required field.'
    }
})